module.exports = {
      id: "video-usage",
      viewBox: "0 0 84 64",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#video",
      toString: function () {
        return this.url;
      }
    }